
require('../../static/css/reset.css');


require('../../common/layout/header/header').run();
require('../../common/layout/footer/footer').run();

require('../../sass/pageNotFound/pageNotFound.scss');

$('.pnf-btn').on('click', function(){
    window.location.href = "/user/bookHotel.do"
})


// WEBPACK FOOTER //
// ./src/js/pageNotFound/pageNotFound.js